import React from "react";
import styled from "styled-components";


export default styled.span`
    display: block;
    width: 6%;
    text-align: right;
    margin: 0 20px;
    margin-right: 0 !important;
    margin-left: 0 !important;
    line-height: 8px;
    font-weight: 700;
    font-size: 30px;
    margin-top: 10px !important;
    color: #888888;
    position: relative;
    box-sizing: border-box;
    overflow: visible;

    @media(max-width: 1553px) {
        width: 4%;
    }

    @media(max-width: 1024px) {
        width: 5%;
    }
`;
